import React from 'react';
import { Page, WatermarkText, ReportTypeText } from './styled';

export class PageLayoutGenerator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pages: [],
    };
    this.pages = [
      { height: 0, children: [] },
    ];

    this.pageRef = React.createRef();
    this.children = React.Children.toArray(React.Children.map(this.props.children, (child, index) => {
      this[`child_ref_${index}`] = React.createRef();
      return React.cloneElement(child, { ref: this[`child_ref_${index}`] });
    }));
  }

  componentDidMount() {
    // max height 1011px
    this.children.map((child, index) => {
      const currentChildRefRect = this[`child_ref_${index}`].current.getBoundingClientRect();
      for (let i = 0; i < this.pages.length; i++) {
        if (this.pages[i].height + currentChildRefRect.height < 1011) {
          this.pages[i].height += currentChildRefRect.height;
          this.pages[i].children.push(child);
        } else {
          this.pages.push({ height: currentChildRefRect.height, children: [child] });
          break;
        }
      }
    });

    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      pages: this.pages,
    });
  }

  render() {
    if (this.pages[0].children.length) {
      return (<React.Fragment>
        {this.pages.map(page => <Page>
          {page.children}
          <WatermarkText>KNOTCH BLUEPRINT</WatermarkText>
          <ReportTypeText>COMPARISON REPORT</ReportTypeText>
        </Page>)}
      </React.Fragment>);
    }
    return <Page ref={this.pageRef}>{this.children}</Page>;
  }
}

export default PageLayoutGenerator;
